import React, { useMemo, useContext, useState } from 'react'
import { Form, Col, Row } from 'react-bootstrap'
import objectPath from 'object-path'
import { DesignContext } from 'contexts/DesignContext'

import Label from './Label'
import AutocompleteContent from './autocomplete/index'
import { isEmpty } from '../action/condition/State'

const CustomAutocomplete = (props) => {
  let { uiKey, value, uischema, errors = {}, label } = props
  let { key, require } = uischema
  let errorArray = objectPath.get(errors, uiKey) || []

  const designContext = useContext(DesignContext)
  const { elementAction } = designContext

  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', key])
  let isEnable = objectPath.get(elementAction, ['isEnable', key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  let hasRequire = objectPath.has(elementAction, ['isRequire', key])
  let requireMessage = objectPath.get(elementAction, ['isRequire', key])
  let showRequireMessage = hasRequire
    ? typeof requireMessage !== 'boolean'
    : require
  let isRequire = hasRequire ? Boolean(requireMessage) : require
  let showRequire = isRequire && isEmpty(value)

  let hasWarning = objectPath.has(elementAction, ['isWarning', key])
  let warningMessage = objectPath.get(elementAction, ['isWarning', key])
  let showWarningMessage = hasWarning
    ? typeof warningMessage !== 'boolean'
    : warningMessage

  const [labelField, setLabelField] = useState(value)
  const [options, setOptions] = useState([])

  return (
    <Form.Group className="mb-0" controlId={uischema.controlId}>
      <Row className="w-100 mx-0">
        <Label
          {...props}
          uischema={uischema}
          label={label}
          isRequire={isRequire}
          isEnable={!isReadOnly}
        />
        <Col sm={uischema.elementWidth} className="mt-1 p-0">
          <AutocompleteContent
            {...props}
            labelField={labelField}
            setLabelField={setLabelField}
            options={options}
            setOptions={setOptions}
            isRequire={isRequire}
            showRequire={showRequire}
          />
        </Col>
        {uischema.suffixText && (
          <Col className="d-flex align-items-center mt-1 pr-0" sm="auto">
            <Form.Label className={`m-0 w-100`}>
              {uischema.suffixText}
            </Form.Label>
          </Col>
        )}
      </Row>
      <ul className="m-0 mt-2">
        {showRequire && showRequireMessage && requireMessage && (
          <li className="text-danger">{requireMessage}</li>
        )}
        {showWarningMessage && warningMessage && (
          <li className="text-danger">{warningMessage}</li>
        )}
        {errorArray.map((error, index) => (
          <li key={`error-${uiKey}-${index + 1}`} className="text-danger">
            {error}
          </li>
        ))}
      </ul>
    </Form.Group>
  )
}

export default CustomAutocomplete
